import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import crossConnectionsState from './state';
const crossConnectionsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => crossConnectionsState);
    },
    initialState: crossConnectionsState,
    name: 'crossConnections',
    reducers: {
        errorReceiveCreateCrossConnection: state => {
            state.requestingCreateCrossConnection = false;
        },
        errorReceiveCrossConnections: state => {
            state.crossConnections = undefined;
            state.requestingCrossConnections = false;
        },
        errorReceiveInterfaceCrossConnections: state => {
            state.interfaceCrossConnections = undefined;
            state.requestingInterfaceCrossConnections = false;
        },
        errorReceiveLockerCrossConnections: state => {
            state.lockerCrossConnections = undefined;
            state.requestingLockerCrossConnections = false;
        },
        errorReceiveModifyCrossConnection: state => {
            state.requestingModifyCrossConnection = false;
        },
        errorReceiveRemoveCrossConnection: state => {
            state.requestingRemoveCrossConnection = false;
        },
        errorReceiveSiteCrossConnections: state => {
            state.siteCrossConnections = undefined;
            state.requestingSiteCrossConnections = false;
        },
        failedReceiveCreateCrossConnection: state => {
            state.requestingCreateCrossConnection = false;
        },
        failedReceiveCrossConnections: state => {
            state.crossConnections = undefined;
            state.requestingCrossConnections = false;
        },
        failedReceiveInterfaceCrossConnections: state => {
            state.interfaceCrossConnections = undefined;
            state.requestingInterfaceCrossConnections = false;
        },
        failedReceiveLockerCrossConnections: state => {
            state.lockerCrossConnections = undefined;
            state.requestingLockerCrossConnections = false;
        },
        failedReceiveModifyCrossConnection: state => {
            state.requestingModifyCrossConnection = false;
        },
        failedReceiveRemoveCrossConnection: state => {
            state.requestingRemoveCrossConnection = false;
        },
        failedReceiveSiteCrossConnections: state => {
            state.siteCrossConnections = undefined;
            state.requestingSiteCrossConnections = false;
        },
        receiveCreateCrossConnection: {
            prepare: crossConnection => {
                return {
                    payload: {
                        crossConnection
                    }
                };
            },
            reducer: (state, action) => {
                const { crossConnection } = action.payload;
                state.crossConnections = state.crossConnections ? [...state.crossConnections, crossConnection] : [crossConnection];
                state.interfaceCrossConnections = state.interfaceCrossConnections ? [...state.interfaceCrossConnections, crossConnection] : [crossConnection];
                state.lockerCrossConnections = state.lockerCrossConnections ? [...state.lockerCrossConnections, crossConnection] : [crossConnection];
                state.requestingCreateCrossConnection = false;
                state.siteCrossConnections = state.siteCrossConnections ? [...state.siteCrossConnections, crossConnection] : [crossConnection];
            }
        },
        receiveCrossConnections: {
            prepare: crossConnections => {
                return {
                    payload: {
                        crossConnections
                    }
                };
            },
            reducer: (state, action) => {
                const { crossConnections } = action.payload;
                state.crossConnections = crossConnections;
                state.requestingCrossConnections = false;
            }
        },
        receiveInterfaceCrossConnections: {
            prepare: crossConnections => {
                return {
                    payload: {
                        crossConnections
                    }
                };
            },
            reducer: (state, action) => {
                const { crossConnections } = action.payload;
                state.interfaceCrossConnections = crossConnections;
                state.requestingInterfaceCrossConnections = false;
            }
        },
        receiveLockerCrossConnections: {
            prepare: crossConnections => {
                return {
                    payload: {
                        crossConnections
                    }
                };
            },
            reducer: (state, action) => {
                const { crossConnections } = action.payload;
                state.lockerCrossConnections = crossConnections;
                state.requestingLockerCrossConnections = false;
            }
        },
        receiveModifyCrossConnection: {
            prepare: crossConnection => {
                return {
                    payload: {
                        crossConnection
                    }
                };
            },
            reducer: (state, action) => {
                const { crossConnection } = action.payload;
                state.crossConnections = state.crossConnections && state.crossConnections.map(connection => connection.vcid === crossConnection.vcid ? crossConnection : connection);
                state.interfaceCrossConnections = state.interfaceCrossConnections && state.interfaceCrossConnections.map(connection => connection.vcid === crossConnection.vcid ? crossConnection : connection);
                state.lockerCrossConnections = state.lockerCrossConnections && state.lockerCrossConnections.map(connection => connection.vcid === crossConnection.vcid ? crossConnection : connection);
                state.requestingModifyCrossConnection = false;
                state.siteCrossConnections = state.siteCrossConnections && state.siteCrossConnections.map(connection => connection.vcid === crossConnection.vcid ? crossConnection : connection);
            }
        },
        receiveRemoveCrossConnection: {
            prepare: crossConnection => {
                return {
                    payload: {
                        crossConnection
                    }
                };
            },
            reducer: (state, action) => {
                const { crossConnection } = action.payload;
                state.crossConnections = state.crossConnections && state.crossConnections.map(connection => connection.vcid === crossConnection.vcid ? crossConnection : connection);
                state.interfaceCrossConnections = state.interfaceCrossConnections && state.interfaceCrossConnections.map(connection => connection.vcid === crossConnection.vcid ? crossConnection : connection);
                state.lockerCrossConnections = state.lockerCrossConnections && state.lockerCrossConnections.map(connection => connection.vcid === crossConnection.vcid ? crossConnection : connection);
                state.requestingRemoveCrossConnection = false;
                state.siteCrossConnections = state.siteCrossConnections && state.siteCrossConnections.map(connection => connection.vcid === crossConnection.vcid ? crossConnection : connection);
            }
        },
        receiveSiteCrossConnections: {
            prepare: crossConnections => {
                return {
                    payload: {
                        crossConnections
                    }
                };
            },
            reducer: (state, action) => {
                const { crossConnections } = action.payload;
                state.siteCrossConnections = crossConnections;
                state.requestingSiteCrossConnections = false;
            }
        },
        requestCreateCrossConnection: {
            prepare: (description, sourcePort, targetPort) => {
                return {
                    payload: {
                        description,
                        sourcePort,
                        targetPort
                    }
                };
            },
            reducer: state => {
                state.requestingCreateCrossConnection = true;
            }
        },
        requestCrossConnections: state => {
            state.requestingCrossConnections = true;
        },
        requestInterfaceCrossConnections: {
            prepare: (deviceID, interfaceID) => {
                return {
                    payload: {
                        deviceID,
                        interfaceID
                    }
                };
            },
            reducer: state => {
                state.requestingInterfaceCrossConnections = true;
            }
        },
        requestLockerCrossConnections: {
            prepare: deviceID => {
                return {
                    payload: {
                        deviceID
                    }
                };
            },
            reducer: state => {
                state.requestingLockerCrossConnections = true;
            }
        },
        requestModifyCrossConnection: {
            prepare: (description, vcid) => {
                return {
                    payload: {
                        description,
                        vcid
                    }
                };
            },
            reducer: state => {
                state.requestingModifyCrossConnection = true;
            }
        },
        requestRemoveCrossConnection: {
            prepare: vcid => {
                return {
                    payload: {
                        vcid
                    }
                };
            },
            reducer: state => {
                state.requestingRemoveCrossConnection = true;
            }
        },
        requestSiteCrossConnections: {
            prepare: locationSlug => {
                return {
                    payload: {
                        locationSlug
                    }
                };
            },
            reducer: state => {
                state.requestingSiteCrossConnections = true;
            }
        },
        resetCrossConnections: () => crossConnectionsState
    }
});
export const { errorReceiveCreateCrossConnection, errorReceiveCrossConnections, errorReceiveInterfaceCrossConnections, errorReceiveLockerCrossConnections, errorReceiveModifyCrossConnection, errorReceiveRemoveCrossConnection, errorReceiveSiteCrossConnections, failedReceiveCreateCrossConnection, failedReceiveCrossConnections, failedReceiveInterfaceCrossConnections, failedReceiveLockerCrossConnections, failedReceiveModifyCrossConnection, failedReceiveRemoveCrossConnection, failedReceiveSiteCrossConnections, receiveCreateCrossConnection, receiveCrossConnections, receiveInterfaceCrossConnections, receiveLockerCrossConnections, receiveModifyCrossConnection, receiveRemoveCrossConnection, receiveSiteCrossConnections, requestCreateCrossConnection, requestCrossConnections, requestInterfaceCrossConnections, requestLockerCrossConnections, requestModifyCrossConnection, requestRemoveCrossConnection, requestSiteCrossConnections, resetCrossConnections } = crossConnectionsSlice.actions;
export default crossConnectionsSlice.reducer;
